module.exports = __webpack_public_path__ + "static/img/exclamation.f33795de.svg";